module.exports = __webpack_public_path__ + "static/media/link-arrow.169b7b77.svg";